import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { ICompany } from '@nxsys/types/models/company';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppInput from '@nxsys/components/AppInput';
import { Form, Row, Col } from 'antd';
import { useImperativeHandle, Ref, useEffect, useState } from 'react';

type BoostworksSettingsFormRef = {
  submit: () => void;
};

export type BoostworksSettingsFormValues = {
  clientId: string;
  ivKey: string;
  symmetricKey: string;
  clientKey: string;
  secretKey: string;
};

type BoostworksSettingsFormProps = {
  companyData?: ICompany;
  formRef?: Ref<BoostworksSettingsFormRef>;
  onSubmit?: (values: BoostworksSettingsFormValues) => void;
};

const BoostworksSettingsForm: React.FC<BoostworksSettingsFormProps> = ({
  companyData,
  formRef,
  onSubmit,
}) => {
  const { messages } = useTypedIntl();
  const [form] = Form.useForm();
  const [needReinitializeForm, setNeedReinitializeForm] = useState(true);

  useImperativeHandle(formRef, () => ({
    submit: () => {
      form.submit();
    },
  }));

  const onFinish = (values: any) => {
    onSubmit?.(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
  };

  useEffect(() => {
    if (companyData?.bootsworkSettings && needReinitializeForm) {
      const initialValues = {
        clientId: companyData.bootsworkSettings.clientId || '',
        ivKey: companyData.bootsworkSettings.ivKey || '',
        symmetricKey: companyData.bootsworkSettings.symmetricKey || '',
        clientKey: companyData.bootsworkSettings.clientKey || '',
        secretKey: companyData.bootsworkSettings.secretKey || '',
      };
      form.setFieldsValue(initialValues);
      setNeedReinitializeForm(false);
    }
  }, [companyData?.bootsworkSettings]);

  return (
    <AppFormContainer
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
    >
      <Row gutter={24}>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.clientId']}
            name="clientId"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.ivKey']}
            name="ivKey"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.symmetricKey']}
            name="symmetricKey"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.clientKey']}
            name="clientKey"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
        <Col sm={24} md={12}>
          <Form.Item
            label={messages['common.secretKey']}
            name="secretKey"
            rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
          >
            <AppInput
              placeholder={messages['form.enter']}
              allowCapitalize={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </AppFormContainer>
  );
};

export default BoostworksSettingsForm;
